import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from 'ngx-pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';

import { WfTableComponent } from './table-sort/wf-table.component';
import { TableSortComponent } from './table-sort/table-sort.component';
import { CheckboxListComponent } from './checkbox-list/checkbox-list.component';
import { DropdownMultiselectComponent } from './dropdown-multiselect/dropdown-multiselect.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { FilterComponent } from './filter/filter.component';
import { ReportsFilterComponent } from './reports-filter/reports-filter.component';
import { InstanceHistoryResultComponent } from './reports-filter/instance-history-result/instance-history-result.component';
import { ShowByRequiredPermissionDirective } from './_directives/show-by-required-permission.directive';
import { SafeHtmlPipe } from '../services/pipes/safe-html.pipe';
import { LocalDatetimePipe } from '../services/pipes/local-datetime.pipe';
import {BrDatetimePipe} from '../services/pipes/br-dateTime.pipe';
import {BrDecimalPipe} from '../services/pipes/br-decimal.pipe';
import { FileUploadDragDropDirective } from './_directives/file-upload-drag-drop.directive';
import {FileSizePipe} from '../services/pipes/file-size.pipe';



@NgModule({
  declarations: [
    WfTableComponent,
    TableSortComponent,
    CheckboxListComponent,
    DropdownMultiselectComponent,
    ContextMenuComponent,
    FilterComponent,
    ReportsFilterComponent,
    InstanceHistoryResultComponent,
    ShowByRequiredPermissionDirective,
    SafeHtmlPipe,
    LocalDatetimePipe,
    BrDatetimePipe,
    BrDecimalPipe,
    FileUploadDragDropDirective,
    FileSizePipe
  ],
  entryComponents: [
    WfTableComponent,
    TableSortComponent,
    CheckboxListComponent,
    DropdownMultiselectComponent,
    ContextMenuComponent,
    FilterComponent,
    ReportsFilterComponent,
    InstanceHistoryResultComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxPaginationModule,
    NgSelectModule
  ],
  exports: [
    WfTableComponent,
    TableSortComponent,
    CheckboxListComponent,
    DropdownMultiselectComponent,
    ContextMenuComponent,
    FilterComponent,
    ReportsFilterComponent,
    InstanceHistoryResultComponent,
    ShowByRequiredPermissionDirective,
    SafeHtmlPipe,
    LocalDatetimePipe,
    BrDatetimePipe,
    BrDecimalPipe,
    NgSelectModule,
    FileUploadDragDropDirective,
    FileSizePipe
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class CommonComponentsModule { }
